var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.TeamDashboardComponent,_vm._b({tag:"component"},'component',{..._vm.$props, ..._vm.$attrs},false))
}
var staticRenderFns = []

export { render, staticRenderFns }